import { GenericChildState } from "@hopper-b2b/checkout";
import { ActionTypes } from "./actions";
import { TermsAndConditionsEventTypes } from "./events";

export const getMachineState = {
  initial: GenericChildState.idle,
  states: {
    [GenericChildState.idle]: {
      on: {
        [TermsAndConditionsEventTypes.TOGGLE_ACCEPTED]: {
          actions: ActionTypes.toggleAccepted,
        },
      },
    },
  },
};
